import React, { Component } from "react";
import { Link } from "react-router-dom";
import { loading } from "../components/CustomComponent.js";
import Navbar from "../components/Navbar.js";
import Footer from "../components/Footer.js";
import { SectionHead, Btn, Reveal, Photo } from "../components/ui.js";
import { SceneArt } from "../components/illustrations.js";
import { CATS } from "../data/services.js";

/* ============================================================
   LEVELUP ONE — Services (layout อ้างอิงเว็บต้นแบบ)
   carousel hero → 3 ทางเลือก → แท็บ 6 หมวด/บริการ → why → cta
   anchors: #saas-products #custom-development #it-talent
            #ai-solutions #consulting #brand-stage
   ============================================================ */

const SLIDES = [
  { eyebrow: "PORTFOLIO · BRAND STAGE", title: "Boutique Hotel / Booking", sub: "เว็บไซต์ + ระบบจองห้องพัก พร้อม booking flow ที่ลื่นไหล", scene: "ecommerce", tag: "ดูบริการใน Brand Stage" },
  { eyebrow: "PORTFOLIO · AI SOLUTIONS", title: "ร้านอาหาร AI POS", sub: "ระบบขายหน้าร้าน + ผู้ช่วย AI สรุปยอดและสต็อกอัตโนมัติ", scene: "retail", tag: "ดูบริการใน AI Solutions" },
  { eyebrow: "PORTFOLIO · CUSTOM", title: "แอประบบทำความสะอาด", sub: "จองคิว จัดทีม และติดตามงานแบบเรียลไทม์", scene: "chat", tag: "ดูบริการ Custom Development" },
];

const CHOICES = [
  { num: "01 · จ้างทีมในองค์กร", title: "Hire · In-house", desc: "คุมงานได้เต็มที่ แต่ต้องลงทุนสูงและใช้เวลาในการสร้างทีมนานหลายเดือน", foot: "เหมาะกับองค์กรใหญ่ที่มีงบและเวลา" },
  { num: "02 · AI / No-code เอง", title: "DIY · AI Tools", desc: "เริ่มเร็วและประหยัด แต่ต่อระบบเดิมยาก และมักติดตอนต้องปรับแต่งเชิงลึก", foot: "เหมาะกับงานเล็ก ไม่ซับซ้อน" },
  { num: "03 · ร่วมงานกับเรา", title: "LevelUp One", desc: "ทำงานบนระบบเดิมของคุณ ส่งมอบไวภายในไม่กี่สัปดาห์ พร้อมทีมดูแลต่อเนื่อง", foot: "→ ครบ จบ คุ้มค่าที่สุด" },
];


const WHY = [
  { num: "01", title: "ทำงานบนระบบเดิม (LINE / POS / Excel)", desc: "ไม่ต้องรื้อของเดิมที่ใช้อยู่ เราต่อยอดให้ทำงานร่วมกันได้", tag: "Integration ครบ" },
  { num: "02", title: "ทีม AI หลายบทบาท ทำงานพร้อมกัน", desc: "บัญชี คลัง ขาย HR รายงาน และบริการลูกค้า ครบในที่เดียว", tag: "ครบทุกแผนก" },
  { num: "03", title: "ส่งมอบไว ใช้งานได้จริง", desc: "เน้นเห็นผลภายในไม่กี่สัปดาห์ แล้วต่อยอดทีละก้าว", tag: "2–4 สัปดาห์" },
  { num: "04", title: "เริ่มจากปรึกษาฟรี ไม่มีข้อผูกมัด", desc: "คุย 30 นาทีเพื่อประเมินก่อน ไม่ต้องเสี่ยง", tag: "ฟรี 30 นาที" },
  { num: "05", title: "ราคาชัดเจน คุ้มค่า", desc: "ประเมินตามขอบเขตงานจริง ไม่มีค่าใช้จ่ายแอบแฝง", tag: "โปร่งใส" },
];

export default class Services extends Component {
  state = { slide: 0, cat: 0 };

  componentDidMount() {
    loading(false);
    this.applyHash();
    window.addEventListener("hashchange", this.applyHash);
    if (!window.location.hash) window.scrollTo(0, 0);
  }
  componentWillUnmount() {
    window.removeEventListener("hashchange", this.applyHash);
  }
  applyHash = () => {
    const id = decodeURIComponent((window.location.hash || "").slice(1));
    const idx = CATS.findIndex((c) => c.id === id);
    if (idx >= 0) {
      this.setState({ cat: idx });
      const el = document.getElementById("svc-tabs");
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 60);
    }
  };

  prev = () => this.setState((s) => ({ slide: (s.slide - 1 + SLIDES.length) % SLIDES.length }));
  next = () => this.setState((s) => ({ slide: (s.slide + 1) % SLIDES.length }));

  render() {
    const { slide, cat } = this.state;
    const s = SLIDES[slide];
    const active = CATS[cat];

    return (
      <div className="nx">
        <Navbar />

        {/* ===== HERO CAROUSEL ===== */}
        <section className="nx-svc-hero">
          <div className="container">
            <div className="nx-carousel">
              <button className="nx-carousel__arrow nx-carousel__arrow--prev" onClick={this.prev} aria-label="ก่อนหน้า">‹</button>
              <button className="nx-carousel__arrow nx-carousel__arrow--next" onClick={this.next} aria-label="ถัดไป">›</button>
              <div className="row align-items-center g-5 nx-carousel__track">
                <div className="col-12 col-lg-5">
                  <div className="nx-svc-hero__eyebrow">{s.eyebrow}</div>
                  <h1 className="nx-svc-hero__title">{s.title}</h1>
                  <div className="nx-svc-hero__sub">{s.sub}</div>
                  <div className="nx-svc-hero__actions">
                    <a href="#svc-tabs" className="nx-btn nx-btn--accent">ดูตัวอย่าง</a>
                    <a href="#svc-tabs" className="nx-btn nx-btn--light">{s.tag} →</a>
                  </div>
                </div>
                <div className="col-12 col-lg-7">
                  <div className="nx-browser">
                    <div className="nx-browser__bar">
                      <i style={{ background: "#f87171" }} /><i style={{ background: "#fbbf24" }} /><i style={{ background: "#34d399" }} />
                      <span className="nx-browser__url" />
                    </div>
                    <div className="nx-browser__body"><SceneArt kind={s.scene} /></div>
                  </div>
                </div>
              </div>
              <div className="nx-carousel__dots">
                {SLIDES.map((_, i) => (
                  <button key={i} className={`nx-carousel__dot ${i === slide ? "is-active" : ""}`} onClick={() => this.setState({ slide: i })} aria-label={`สไลด์ ${i + 1}`} />
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* ===== 3 CHOICES ===== */}
        <section className="nx-section">
          <div className="container">
            <Reveal>
              <SectionHead eyebrow="ก่อนตัดสินใจ" title="3 ทางเลือกที่ SME ไทยกำลังพิจารณาอยู่ — ตรง ๆ"
                subtitle="เปรียบเทียบให้เห็นภาพ ว่าทำไมการร่วมงานกับเราถึงคุ้มค่าที่สุดสำหรับธุรกิจที่อยากโตเร็ว" />
            </Reveal>
            <div className="row g-4 mt-2">
              {CHOICES.map((c, i) => (
                <div className="col-12 col-md-4" key={c.num}>
                  <Reveal delay={i * 70}>
                    <div className={`nx-card nx-choice ${i === 2 ? "" : ""}`} style={i === 2 ? { borderColor: "var(--nx-primary)" } : undefined}>
                      <div className="nx-choice__num">{c.num}</div>
                      <h3 className="nx-card__title mt-2">{c.title}</h3>
                      <div className="nx-choice__divider" />
                      <p className="nx-card__desc">{c.desc}</p>
                      <p className="nx-choice__foot mt-3">{c.foot}</p>
                    </div>
                  </Reveal>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ===== TABBED SERVICES ===== */}
        <section className="nx-section nx-bg-surface" id="svc-tabs">
          <div className="container">
            {/* invisible anchors เพื่อให้ลิงก์ #หมวด ใช้งานได้ */}
            {CATS.map((c) => <span key={c.id} id={c.id} className="nx-anchor" style={{ position: "absolute" }} />)}
            <Reveal>
              <SectionHead eyebrow="บริการของเรา" title="5 หมวดบริการ · 32 บริการพร้อมส่งมอบ"
                subtitle="เลือกหมวดที่สนใจทางซ้าย เพื่อดูบริการย่อยทั้งหมดในหมวดนั้น" />
            </Reveal>

            <div className="nx-tabs mt-4">
              {/* left: categories */}
              <div className="nx-tabs__list">
                {CATS.map((c, i) => (
                  <button key={c.id} className={`nx-tabs__item ${i === cat ? "is-active" : ""}`} onClick={() => this.setState({ cat: i })}>
                    <span className="nx-tabs__ico" aria-hidden="true">{c.ico}</span>
                    <span>{c.name}<small>{c.tagline}</small></span>
                  </button>
                ))}
              </div>

              {/* right: panel */}
              <div className="nx-tabs__panel">
                <div className="nx-tabs__feature">
                  <Photo
                    src={active.feature.img}
                    alt={active.feature.title}
                    fallback={active.ico}
                    className="nx-tabs__feature-photo"
                  />

                  <div className="nx-tabs__feature-body">
                    <span className="nx-eyebrow">{active.tagline}</span>
                    <h3 className="nx-card__title mt-2" style={{ fontSize: "1.4rem" }}>{active.feature.title}</h3>
                    <p className="nx-card__desc mt-1">{active.feature.desc}</p>
                  </div>
                </div>

                <div className="row g-3">
                  {active.items.map((it) => (
                    <div className="col-12 col-sm-6" key={it.slug}>
                      <Link to={`/services/${active.id}/${it.slug}`} className="nx-subcard d-block">
                        <div className="nx-subcard__head">
                          <span className="nx-subcard__ico" aria-hidden="true">{it.ico}</span>
                          <span className="nx-subcard__title">{it.title}</span>
                        </div>
                        <p className="nx-subcard__desc">{it.desc}</p>
                        <span className="nx-subcard__link">ดูเพิ่มเติม →</span>
                      </Link>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ===== WHY (dark) ===== */}
        <section className="nx-section nx-why-band">
          <div className="container">
            <Reveal>
              <SectionHead eyebrow="เหตุผลที่เลือกเรา" title={<>ทำไม SME ไทย เลือก<span style={{ color: "var(--nx-accent)" }}>เรา</span></>} />
            </Reveal>
            <div className="mt-4">
              {WHY.map((w) => (
                <Reveal key={w.num}>
                  <div className="nx-whyrow">
                    <div className="nx-whyrow__num">{w.num}</div>
                    <div>
                      <div className="nx-whyrow__title">{w.title}</div>
                      <div className="nx-whyrow__desc">{w.desc}</div>
                    </div>
                    <div className="nx-whyrow__tag">{w.tag}</div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </section>

        {/* ===== CTA 30 min ===== */}
        <section className="nx-section">
          <div className="container">
            <Reveal>
              <SectionHead title={<>คุยกัน 30 นาที ออกตอนไหนคุณ <span className="nx-gradient-text">เห็นเลย</span> ว่า fit หรือไม่</>}
                subtitle="ไม่ต้องเตรียมอะไรมาก แค่เล่าปัญหาให้ฟัง แล้วเราจะช่วยประเมินแนวทางผ่าน LINE / POS / Excel ของคุณให้ทันที" />
              <div className="d-flex flex-wrap gap-3 mt-4">
                <Btn to="/booking">นัด Founder · 30 นาที</Btn>
                <Btn href="https://line.me" variant="ghost">หรือทักผ่าน LINE</Btn>
              </div>
            </Reveal>
          </div>
        </section>

        {/* ===== TAGLINE ===== */}
        <section className="nx-section--tight nx-bg-soft">
          <div className="container">
            <Reveal>
              <div className="nx-tagline">
                <h2 className="nx-tagline__title">สร้างจากไทย — <span className="nx-gradient-text">ส่งมอบทั่วโลก</span></h2>
                <div className="nx-tagline__card">
                  <span className="nx-eyebrow">เริ่มต้นง่าย ๆ</span>
                  <p className="nx-card__desc my-3">สมัครเป็น Early Adopter วันนี้ รับสิทธิ์ทดลองใช้ฟรี 30 วัน</p>
                  <Btn to="/register" block>สมัครสมาชิก</Btn>
                </div>
              </div>
            </Reveal>
          </div>
        </section>

        <Footer />
      </div>
    );
  }
}
